interface Ok<T> {
  type: "OK";
  value: T;
}

interface Err<T> {
  type: "ERROR";
  details: T;
}

export type Unit = {};
export type Result<TErr, TVal> = Ok<TVal> | Err<TErr>;

export const ok = <T>(value: T): Ok<T> => ({
  type: "OK",
  value
});

export const err = <T>(details: T): Err<T> => ({
  type: "ERROR",
  details
});

export const isOk = <TErr, TVal>(
  result: Result<TErr, TVal>
): result is Ok<TVal> => result.type === "OK";

export const isErr = <TErr, TVal>(
  result: Result<TErr, TVal>
): result is Err<TErr> => result.type === "ERROR";

export const coerce = <TErr, TVal>(
  result: Result<TErr, TVal>
): TVal | undefined => (isOk(result) ? result.value : undefined);
